
import { computed, defineComponent, PropType } from 'vue'
import tinycolor from 'tinycolor2'
export default defineComponent({
  name: 'gradient-defs',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String as PropType<'linear' | 'radial'>,
    },
    gradient: {
      type: Array
    },
    rotate: {
      type: Number,
      default: 90,
    },
    color: {
      type: Array,
    },
    postion: {
      type: String,
    },
  },
  setup(props) {
    const g = computed(() => {
      let gs = props.gradient || []
      const p: any[] = [0,100]
      if (props.gradient && props.gradient.length <= 0) {
        props.color?.forEach((c: any,ind: any) => {
          p?.forEach((p: any,index: any) => {
            if (ind !== index) return
            gs.push({
              c:c,
              p: p
            })
          })
        })
      }
      else {
        gs = props.gradient || []
      }
      return gs
    })
    
    return {
      g,tinycolor
    }
  }
})

